import React from 'react';
import { ReactComponent as HealthTrackerEmpty } from 'assets/images/EmptyState/Progress/HealthTrackerEmpty.svg';
import { WidgetCard } from 'components/WidgetCard/WidgetCard';
import { EmptyWidgetState } from 'components/EmptyWidgetState/EmptyWidgetState';
import { useTranslationContext } from 'contexts/TranslationContext/TranslationContext';

export interface HealthTrackerEmptyStateProps {
  onBrowseTrackers: () => void;
}

export const HealthTrackerEmptyState: React.FC<HealthTrackerEmptyStateProps> = ({
  onBrowseTrackers,
}) => {
  const { translation } = useTranslationContext();

  return (
    <WidgetCard icon={null} title={translation('health_tracker')} showHeader={false}>
      <EmptyWidgetState
        icon={HealthTrackerEmpty}
        title={translation('add_health_tracker')}
        description={translation('add_health_tracker_body')}
        buttonText={translation('browse_trackers')}
        onButtonClick={onBrowseTrackers}
      />
    </WidgetCard>
  );
};
